import { BuildAlbumFromApiResponse } from "@helpers/albumFactory";
import { GetApiErrorMessage } from "@helpers/apiErrorHelper";

export default {
    mixins: [],
    data: () => ({}),
    computed: {
        whatRouteRedirect() {
            return this.$store.getters.getLanguage == "es"
                ? "es.albumes"
                : "albumes";
        },
        // Computed property to identify whether the current route is Album.
        isAlbumRoute() {
            const routeNameCurrent = this.$route.name;
            return (
                routeNameCurrent == "albumes" ||
                routeNameCurrent == "es.albumes"
            );
        },
    },
    methods: {
        /**
         * hasDownloadCode
         * @param downloadCode - The code to be checked.
         * @returns A boolean value.
         */
        hasDownloadCode(__downloadCode) {
            return Object.values(this.$store.state.albumes).some(
                (element) => element.code == __downloadCode && element.Type == 0
            );
        },
        /**
         * downloadCode
         * @param downloadCode - The code to be downloaded.
         * @returns void
         */
        async downloadCode(__downloadCode) {
            try {
                const __email = (this.$store.state.email || "")
                    .toString()
                    .trim();
                this.$store.dispatch("setLoading", true);

                if (this.hasDownloadCode(__downloadCode)) {
                    Vue.$toast.open({
                        message: this.$t("Forms.exist_code"),
                        type: "info",
                    });

                    if (this.$route.name != "albumes") {
                        this.$router.push({ name: "albumes" });
                    }

                    return;
                }

                // Saves the download code in the DB so it can be retrieved later in the user's session.
                const codeToSave = {
                    SearchInput: __downloadCode,
                    VisitorEmail: __email,
                    ParkId: null,
                    VisitDate: null,
                    SearchType: 0,
                };

                if (__email) {
                    this.$store.dispatch("VisitorActivity", codeToSave);
                }
                    
                await this.getAlbumsByDownloadCode(__downloadCode);
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                Vue.$toast.open({
                    message: GetApiErrorMessage(
                        error,
                        this.$t("messages.album_error_add")
                    ),
                    type: "error",
                });
            } finally {
                await this.$store.dispatch("setLoading", false);
            }
        },
        /**
         * Function to get data from the download code.
         * @param downloadCode - Download code.
         * @returns 
         */
        async getAlbumsByDownloadCode(code) {
            /* Creates an object with the parameters to send to the API. */
            const parameters = {
                type: 0,
                params: { JoinedCode: code },
            };
            /* Calls the API to get the albums by download code. */
            const response = await this.$store.dispatch(
                "getAlbums",
                parameters
            );

            /*
             * This verifies whether the code has at least one PhotoExperience
             * (album data) in order to continue with the flow.
             */
            const hasPhotoExperience = response.some(
                (item) =>
                    Array.isArray(item.PhotoExperiences) &&
                    item.PhotoExperiences.length > 0
            );

            // Checks whether any item in the response has PhotoExperiences and removes the ones that do not.
            let albumFiltered = response.filter(
                (item) =>
                    Array.isArray(item.PhotoExperiences) &&
                    item.PhotoExperiences.length > 0
            );
            // If there is no associated album, an error message is displayed.
            if (!hasPhotoExperience) {
                Vue.$toast.open({
                    message: this.$t("Validations.code_dont_have_parks"),
                    type: "error",
                });

                return;
            }

            this.formatAlbumsByDownloadCode(albumFiltered);
            this.$store.dispatch("setModalAddAlbum", false);

            if (this.$route.name == "albumes") {
                Vue.$toast.open({
                    message: this.$t("messages.album_add_successfully"),
                    type: "success",
                });

                return;
            } else {
                this.$router.push({ name: "albumes" });
            }
        },
        /**
         * formatAlbumsByDownloadCode
         * @param data - The data returned from the API call.
         * @return void
         */
        formatAlbumsByDownloadCode(data) {
            data.forEach((item) => {
                if (item.PhotoDetails.Type === 0) {
                    
                    let album = this.albumsByDownloadCode(item);
                    this.$store.dispatch("setAlbum", [album]);
                }
            });

            this.$store.dispatch("setDownloadCodeTab", true);
            this.$store.dispatch("setTypeCodeTab", 0);
        },
        /**
         * albumsByDownloadCode
         * @param data - The data returned from the API call.
         * @return album - Returns an album object.
         */
        albumsByDownloadCode(data) {
            return BuildAlbumFromApiResponse(data);
        },
    },
};